module.exports = __webpack_public_path__ + "img/I_illustration.9a417a93.gif";